import * as React from 'react';
import {
  Logging,
  API,
  ResponseError,
  NotificationData,
  Jurisdiction,
  sessionStorageECWizardJurisdictions,
  JurisdictionCollection,
} from '@vcd-ecm-ui/Common';
import { useDispatch } from 'react-redux';

const useJurisdictions = (
  gatewayEndPoint: string,
  reloadKey: string,
  alwaysReload: boolean,
): [Jurisdiction[], NotificationData] => {
  const [jurisdictions, setJurisdictions] = React.useState(null);
  const [jurisdictionNotification, setJurisdictionNotification] = React.useState(null);
  const dispatch = useDispatch();

  const getJurisdictions = () => async (): Promise<void> => {
    try {
      const api = new API(gatewayEndPoint);

      let startRow = 0;
      const pageSize = 1000;
      let jurisdictionsArray: Jurisdiction[] = [];
      let totalJurisdictions = 0;

      // Read all the Jurisdictions
      do {
        const endRow = startRow + pageSize;
        // eslint-disable-next-line no-await-in-loop
        const jurisdictionsApi: JurisdictionCollection = await api.ecwizard.getJurisdictionsV41(startRow, endRow);

        // Get teh Total Number of Jurisdictions
        totalJurisdictions = jurisdictionsApi['@odata.count'];

        Logging.Info('Load Jurisdictions Page:', startRow, endRow, totalJurisdictions, jurisdictionsApi.value.length);

        // Adjust the Start Row
        startRow = endRow;

        // Append the Jurisdictions
        jurisdictionsArray = jurisdictionsArray.concat(jurisdictionsApi.value);
      } while (jurisdictionsArray.length < totalJurisdictions);

      Logging.Debug('Load Jurisdictions:', jurisdictionsArray);

      // Save the Jurisdictions to the Session Storage
      sessionStorage[sessionStorageECWizardJurisdictions] = JSON.stringify(jurisdictionsArray);

      setJurisdictions(jurisdictionsArray);
    } catch (error) {
      const notification: NotificationData = {
        type: 'Error',
        title: 'Jurisdictions Read Error',
        description: 'Unable to read Jurisdictions',
        error: error as ResponseError,
      };
      setJurisdictionNotification(notification);
    }
  };

  React.useEffect(() => {
    // Read the Jurisdictions from the Session Storage if available
    if ((alwaysReload === false) && sessionStorage[sessionStorageECWizardJurisdictions]) {
      setJurisdictions(JSON.parse(sessionStorage[sessionStorageECWizardJurisdictions]));
    } else {
      // Read the Jurisdictions
      dispatch(getJurisdictions());
    }

    return (): void => {
      setJurisdictionNotification(null);
    };
  }, [reloadKey]);

  return [jurisdictions, jurisdictionNotification];
};

export default useJurisdictions;
